exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payments__auth-window__ldVqP{min-width:630px;border-radius:0}@media screen and (max-height:738px){.payments__auth-window__ldVqP{max-height:calc(100% - 60px)}}.payments__auth-modal__1rUcq{background-color:-wix-colors-backgroundColor-95}.payments__auth-modal-content__QNIen{height:100%;padding:0}", ""]);

// exports
exports.locals = {
	"auth-window": "payments__auth-window__ldVqP",
	"authWindow": "payments__auth-window__ldVqP",
	"auth-modal": "payments__auth-modal__1rUcq",
	"authModal": "payments__auth-modal__1rUcq",
	"auth-modal-content": "payments__auth-modal-content__QNIen",
	"authModalContent": "payments__auth-modal-content__QNIen"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/payments/payments.styl
// module id = 1863
// module chunks = 1 3